<template>
  <div>
    <v-btn v-if="canPair" :outlined="!hasSectionPair" small
      :color="`${hasSectionPair ? 'green white--text' : 'amber accent-4'}`" @click="openEditDialog">
      <span v-if="hasSectionPair"> {{ subjectObject.sec_pair }}</span>
      <v-icon>mdi-chevron-down</v-icon>
    </v-btn>
    <span v-else> {{ subjectObject.sec_pair }}</span>

    <v-dialog v-model="isOpenEditDialog" max-width="300" persistent v-if="subjectObject">
      <v-card :loading="loading">
        <v-card-title>จับคู่กลุ่มเรียนวิชา {{ subjectObject.subject_id }}</v-card-title>
        <v-card-text>
          <h3>{{ subjectObject.subject_name_en }}</h3>
          <v-select v-if="pracSections.length > 0" :disabled="loading" :items="pracSections"
            v-model="selectedPracSection"></v-select>
          <h3 class="mt-2 red--text" v-if="pracSections.length === 0 && !loading">ไม่มีข้อมูลกลุ่มจับคู่ / ไม่ต้องจับคู่
          </h3>
        </v-card-text>
        <v-card-actions>
          <v-btn class="green white--text" :disabled="loading" @click="save" v-if="pracSections.length !== 0">บันทึก
          </v-btn>
          <v-btn class="gray" @click="closeEditDialog">ยกเลิก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import tableTableProvider from "@/services/teach_table.provider.js";
const tableTableService = new tableTableProvider();

export default {
  props: {
    subjectObject: {
      type: Object,
      required: true,
    },
    fetch_data: {
      type: Function,
      required: true,
    },
    year: {
      type: String,
      required: true,
    },
    semester: {
      type: String,
      required: true,
    },
  },
  computed: {
    hasSectionPair: function () {
      return (
        this.subjectObject.sec_pair !== null
      );
    },
    canPair: function () {
      return (
        this.subjectObject.class_group_display === 0 &&
        this.subjectObject.lect_or_prac === "ท"
      );
    },
  },
  data() {
    return {
      loading: false,
      sectionPair: "",
      isOpenEditDialog: false,
      pracSections: [],
      selectedPracSection: "",
    };
  },
  methods: {
    async openEditDialog() {
      this.loading = true;
      this.isOpenEditDialog = true;
      await this.fetchSection();
      this.loading = false;
    },
    closeEditDialog() {
      this.isOpenEditDialog = false;
    },
    async fetchSection() {
      this.selectedPracSection = this.subjectObject.sec_pair;
      const response = await tableTableService.getPracticeSectionPair(
        this.subjectObject.subject_id,
        this.year,
        this.semester
      );
      if (response) {
        console.log(response);
        this.pracSections = response;
      }
    },
    async save() {
      if (this.loading) return;

      this.loading = true;
      const response = await tableTableService.setPracticeSectionPair(
        this.subjectObject.teach_table_id,
        this.selectedPracSection
      );
      console.log(response);
      if (response) {
        await this.fetch_data();
        this.loading = false;
        this.isOpenEditDialog = false;
      } else {
        this.loading = false;
        alert("ไม่สามารถบันทึกข้อมูลได้");
      }
    },
  },
};
</script>

<style>
</style>